import React from "react";

import { Link } from "react-router-dom";

import Banner from "../../assets/images/biobo/banner.png";

import "./Label.scss";

export const Label = () => {
  return (
    <section className="label-section">

      <div className="label-image">

        <img
          src={Banner}
          alt="Burn It Or Burn Out"
        />

        <div className="label-overlay" />

      </div>

      <div className="label-content">

        <div className="label-meta">
          <span>04</span>
          <small>RECORD LABEL</small>
        </div>

        <h2>
          BURN IT
          <span>OR BURN OUT.</span>
        </h2>

        <p>
          Born from the LHANGAR cypher in
          2024, BURN IT OR BURN OUT
          represents fire, ambition and
          authenticity. A home for the next
          generation of artists ready to
          shape Moroccan rap.
        </p>

        <Link
          to="/burnitorburnout"
          className="label-link"
        >
          DISCOVER THE LABEL
          <span>↗</span>
        </Link>

      </div>

      <div className="label-marquee">

        <div>
          BURN IT OR BURN OUT •
          NEW GENERATION •
          MOROCCAN RAP •
          BUILD CULTURE •
          BURN IT OR BURN OUT •
          NEW GENERATION •
          MOROCCAN RAP •
          BUILD CULTURE •
        </div>

      </div>

    </section>
  );
};